import { BaseGetApi, BasePostApi, BodyRequest } from '@/core/apis/base-api'

// interface addressListResult {
//   addressListInfo: any
// }

// 地址列表
export class addressListApi extends BasePostApi {
  protected url = '/api/tuser/getMemberAddressLists'

  // public addressList = {}
  set merId(v: string) {
    this.data = {
      ...this.data,
      merchant_id: v,
    }
  }

  set whouseId(v: string) {
    this.data = {
      ...this.data,
      warehouse_id: v,
    }
  }

  public async getAddressListData() {
    const res = await this.postExec()
    const data = res.data
    return res.data
  }
}

// 删除用户地址
export class memberAddressDeleteApi extends BasePostApi {
  protected url = '/api/Member/memberAddressDelete'
  set addrssId(id: string) {
    this.data = {
      ...this.data,
      id,
    }
  }

  public async memberAddressDeleteData() {
    const res = await this.postExec()
    return res
  }
}

// 添加修改收货地址
export class setAddressApi extends BasePostApi {
  protected url = '/api/Address/setAddress'
  set from(form: object) {
    this.data = {
      ...this.data,
      ...form,
    }
  }

  public async setAddress() {
    const res = await this.postExec()
    return res
  }
}

// 当前地址
export class CurrentAdrApi extends BasePostApi {
  protected url = '/api/location/current'

  set lon(v: number) {
    this.data = {
      ...this.data,
      lon: v,
    }
  }

  set lat(v: number) {
    this.data = {
      ...this.data,
      lat: v,
    }
  }
}

// 附近地址列表
export class NearAdrApi extends BasePostApi {
  protected url = '/api/location/nearby'

  set lon(v: number) {
    this.data = {
      ...this.data,
      lon: v,
    }
  }

  set lat(v: number) {
    this.data = {
      ...this.data,
      lat: v,
    }
  }
}

// 设置默认地址
export class SetDefaultAdrApi extends BasePostApi {
  protected url = '/api/Member/setDefaultExpressAddress'

  set id(v: number) {
    this.data = {
      ...this.data,
      id: v,
    }
  }
}

export class ChangeCityApi extends BaseGetApi {
  protected url = '/apiv1/app.geo/cities'
}

export class ReverseApi extends BasePostApi {
  protected url = '/apiv1/app.geo/reverse'

  set lat(v: number) {
    this.data = {
      ...this.data,
      lat: v,
    }
  }

  set lng(v: number) {
    this.data = {
      ...this.data,
      lng: v,
    }
  }

  set deviceLat(v: number) {
    this.data = {
      ...this.data,
      device_lat: v,
    }
  }

  set deviceLon(v: number) {
    this.data = {
      ...this.data,
      device_lon: v,
    }
  }
}

export class TakeoutAdrListApi extends BodyRequest {
  protected url = '/apiv2/takeout.order/userAddressList'

  set mId(v: string) {
    this.data = {
      ...this.data,
      merchant_id: v,
    }
  }

  public async getAddressListData() {
    const res = await this.bodyExec()
    const data = res.data
    return res.data
  }
}

export class TdtMapApi extends BodyRequest {
  protected url = '/apiv2/uc.geo/maptile'

  set postData(v: AnyObject) {
    this.data = {
      ...this.data,
      ...v,
    }
  }
}
